export const TALLY_NON_ONBOARDED_NO_ACTIVE_PLAN =
  "TALLY_NON_ONBOARDED_NO_ACTIVE_PLAN";
export const TALLY_ONBOARDED_NO_ACTIVE_PLAN = "TALLY_ONBOARDED_NO_ACTIVE_PLAN";
export const TALLY_ONBOARDED_PLAN_ENDED = "TALLY_ONBOARDED_PLAN_ENDED";
export const TALLY_ONBOARDED_ACTIVE_PLAN = "TALLY_ONBOARDED_ACTIVE_PLAN";
